var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 73,
    height: 73,
    viewBox: "0 0 73 73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 36,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0071f7",
    d: "M1.432 10.531A1.472 1.472 0 0 0 0 11.873V23.8a6.949 6.949 0 0 0 6.937 6.847 6.788 6.788 0 0 0 6.108-3.737 7.106 7.106 0 0 0 6.108 3.737 6.979 6.979 0 0 0 6.937-6.937 6.883 6.883 0 0 0-6.869-7 6.787 6.787 0 0 0-6.108 3.737A7.108 7.108 0 0 0 7 16.706a6.855 6.855 0 0 0-4.161 1.432v-6.265a1.35 1.35 0 0 0-1.407-1.342zm32.779 6.131a1.245 1.245 0 0 0-.9.492l-3.065 4.095-3.132-4.005a1.322 1.322 0 0 0-1.924-.223 1.4 1.4 0 0 0-.314 1.924l3.58 4.766-3.58 4.7a1.4 1.4 0 0 0 .314 1.924 1.385 1.385 0 0 0 1.924-.223l3.065-4.095 3.043 4.095a1.348 1.348 0 0 0 1.947.223 1.4 1.4 0 0 0 .358-1.924l-3.558-4.766 3.558-4.766a1.422 1.422 0 0 0-.291-1.946 1.467 1.467 0 0 0-1.025-.271zm-27.274 2.8a4.173 4.173 0 1 1-4.162 4.184 4.166 4.166 0 0 1 4.162-4.187zm12.284 0a4.173 4.173 0 1 1-4.162 4.184 4.185 4.185 0 0 1 4.161-4.187z",
    transform: "translate(18.436 13.91)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxDefault);
export default __webpack_public_path__ + "static/media/box-default.d55b9bfbe7f1e3d81e13613c67a31534.svg";
export { ForwardRef as ReactComponent };